import { render, staticRenderFns } from "./GameRondoEs.vue?vue&type=template&id=622aa594&scoped=true&"
import script from "./GameRondoEs.vue?vue&type=script&lang=js&"
export * from "./GameRondoEs.vue?vue&type=script&lang=js&"
import style0 from "./GameRondoEs.vue?vue&type=style&index=0&id=622aa594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622aa594",
  null
  
)

export default component.exports